export enum LabSubCenterActionTypes {
    API_RESPONSE_SUCCESS = '@@labSubCenter/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@labSubCenter/API_RESPONSE_ERROR',

    ADD_LAB_SUB_CENTER = '@@labSubCenter/ADD_LAB_SUB_CENTER',
    EDIT_LAB_SUB_CENTER = '@@labSubCenter/EDIT_LAB_SUB_CENTER',
    GET_LAB_SUB_CENTER = '@@labSubCenter/GET_LAB_SUB_CENTER',
    GET_LAB_SUB_CENTERS = '@@labSubCenter/GET_LAB_SUB_CENTERS',
    RESET = '@@labSubCenter/RESET',
    RESET_SUCCESS = '@@labSubCenter/RESET_SUCCESS',
    RESET_ERROR = '@@labSubCenter/RESET_ERROR',
}
